import { CustomBreadCrump } from "components/General/CustomBreadCrump";
import { TinyLoader } from "components/General/Loader/TinyLoader";
import PageTitle from "components/General/PageTitle";
import { useTranslation } from "next-i18next";
import parse from "html-react-parser";
import Image from "next/image";
import { CustomButton } from "components/General/CustomButton";
import { IContentDetail } from "interfaces/interface_contentDetail";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Category, getServicesCategories } from "api/main";
import { useQuery } from "@tanstack/react-query";

const ContentDetail = ({ data, isLoading }: { data: IContentDetail; isLoading: boolean }) => {
  const { t } = useTranslation();
  const { query, locale } = useRouter();
  const [category, setCategory] = useState<Category | null>(null);
  const serviceId = query.serviceId?.toString();

  const router = useRouter();

  const { data: servicesCategories } = useQuery(["getServicesCategories", locale], () =>
    getServicesCategories(locale)
  );

  useEffect(() => {
    if (servicesCategories?.data) {
      const res = servicesCategories.data.find((item: Category) => item.id === +(serviceId ?? ""));
      if (!!res) setCategory(res);
    }
  }, [serviceId, servicesCategories]);

  return (
    <section className="container mb-[144px]">
      <div className="mb-24">
        <CustomBreadCrump
          data={
            router.pathname.includes("workers")
              ? [
                  {
                    title: t("StaffTraining"),
                    href: "/",
                  },
                  {
                    title: t("Workers"),
                    href: "/teaching/workers",
                  },
                  { title: data?.title, href: "/" },
                ]
              : router.pathname.includes("lifestyle")
              ? [
                  {
                    title: t("StaffTraining"),
                    href: "/",
                  },
                  {
                    title: t("LifeStyle"),
                    href: "/teaching/lifestyle",
                  },
                  { title: data?.title, href: "/" },
                ]
              : router.pathname.includes("services")
              ? [
                  {
                    title: t("Services"),
                    href: "/",
                  },
                  {
                    title: category?.name ?? "",
                    href: `/services/${category?.id}`,
                  },
                  { title: data?.title, href: "/" },
                ]
              : [
                  {
                    title: t("ClinicalResearchDevelopmentCenter"),

                    href: "/",
                  },

                  { title: data?.title, href: "/" },
                ]
          }
        />
      </div>

      <PageTitle title={data?.title} />

      {isLoading ? (
        <div className="min-h-[10rem]">
          <TinyLoader />
        </div>
      ) : (
        <>
          {locale !== "en" && (
            <div className="custom-height relative mt-64 w-full">
              {!!data?.image && (
                <Image className=" rounded-15" alt={data?.title} src={data?.image} fill />
              )}
            </div>
          )}
          <div className="mt-32 text-16 text-gray-666666">
            {!!data?.description && parse(data?.description)}
          </div>

          <div className="mt-64 max-w-[567px] items-center justify-between rounded-10 border border-gray-D0D0D0 px-20 py-12 md:flex">
            <p className="mb-12 md:mb-0">{t("ForMorInformation")}</p>
            <div className=" flex items-center">
              {!!data?.link && (
                <CustomButton
                  className="!w-[154px] rounded-full border border-gray-8C8C8C bg-gray-F3F3F3 text-gray-8C8C8C hover:border-primary-main hover:bg-gray-F3F3F3 hover:text-primary-main"
                  href={data?.link}
                >
                  link
                </CustomButton>
              )}
              {!!data?.pdf && (
                <CustomButton
                  className="!w-[154px] rounded-full border border-gray-8C8C8C bg-gray-F3F3F3 text-gray-8C8C8C ms-14 hover:border-primary-main hover:bg-gray-F3F3F3 hover:text-primary-main"
                  href={data?.pdf}
                >
                  PDF
                </CustomButton>
              )}
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export { ContentDetail };
